"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _dsWeb = require("@olxbr/ds-web");
var _chatModReactComponentsCentralSecurityWeb = require("@olxbr/chat-mod-react-components-central-security-web");
var _propTypes = require("prop-types");
var _style = require("./style");
var _actions = require("../../../actions");
var _selectors = require("../../../selectors");
var _EmptyChatList = require("../../ui/EmptyChatList");
var _ChatListItem = _interopRequireDefault(require("../ChatListItem"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ChatList = /*#__PURE__*/function (_Component) {
  function ChatList() {
    var _this;
    _classCallCheck(this, ChatList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChatList, [].concat(args));
    _defineProperty(_this, "state", {
      loadingMoreChats: false,
      chatListKey: new Date().getTime(),
      currentTab: '1',
      previousTab: null
    });
    _defineProperty(_this, "updateTabs", function (newTab, isChatTabsFavorite, clickAllTabAction) {
      var currentTab = _this.state.currentTab;
      _this.setState({
        previousTab: currentTab,
        currentTab: newTab
      }, function () {
        if (isChatTabsFavorite && _this.state.previousTab === '2' && _this.state.currentTab === '1') {
          //clicou na tab 1 e a anterior era a 2'
          clickAllTabAction();
        }
      });
    });
    _defineProperty(_this, "scrolly", 0);
    _defineProperty(_this, "onScroll", function (event) {
      var _event$currentTarget;
      var chats = _this.props.chats;
      var target = (event === null || event === void 0 || (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || (_event$currentTarget = _event$currentTarget.document) === null || _event$currentTarget === void 0 ? void 0 : _event$currentTarget.documentElement) || event.currentTarget;
      if (chats.length === 0) return;
      var scrollDirection = _this.getScrollDirection(target);
      if (scrollDirection !== 'forward') return;
      if (_this.hasScrolledToTheBottom(target) && _this.shoudFetchMoreChats()) {
        _this.fetchMoreChats();
      }
    });
    _defineProperty(_this, "getScrollDirection", function (target) {
      var scrollTop = target.scrollTop;
      var direction = scrollTop > _this.scrolly ? 'forward' : 'backward';
      _this.scrolly = scrollTop;
      return direction;
    });
    _defineProperty(_this, "getChats", function () {
      var _this$props = _this.props,
        chats = _this$props.chats,
        loading = _this$props.loading;
      var loadingMoreChats = _this.state.loadingMoreChats;
      var result = loading ? _this.chatsLoading() : chats;
      if (loadingMoreChats) {
        return [].concat(_toConsumableArray(result), [{
          roomname: 0,
          pagingLoading: true
        }]);
      }
      return result;
    });
    _defineProperty(_this, "reloadChatList", function () {
      _this.setState({
        chatListKey: new Date().getTime()
      });
    });
    _defineProperty(_this, "fetchMoreChats", function () {
      var _this$props2 = _this.props,
        getChatsAction = _this$props2.getChatsAction,
        oldestChat = _this$props2.oldestChat;
      if (!oldestChat) {
        _this.finishLoading();
        return;
      }
      var originalLastMessageAt = oldestChat.originalLastMessageAt;
      _this.startLoading();
      getChatsAction(originalLastMessageAt).then(function (chats) {
        _this.finishLoading();
        _this.lastResult = chats ? chats.length : 0;
      })["catch"](_this.finishLoading);
    });
    _defineProperty(_this, "startLoading", function () {
      return _this.setState({
        loadingMoreChats: true
      });
    });
    _defineProperty(_this, "finishLoading", function () {
      return _this.setState({
        loadingMoreChats: false
      });
    });
    _defineProperty(_this, "shoudFetchMoreChats", function () {
      var loadingMoreChats = _this.state.loadingMoreChats;
      return !loadingMoreChats && _this.lastResult;
    });
    _defineProperty(_this, "hasScrolledToTheBottom", function (target) {
      if (!target) return false;
      var scrollHeight = target.scrollHeight,
        clientHeight = target.clientHeight,
        scrollTop = target.scrollTop;
      return scrollHeight - scrollTop - clientHeight < 150;
    });
    _defineProperty(_this, "chatsLoading", function () {
      return Array.from(new Array(15), function (_, index) {
        return {
          roomname: index,
          isLoading: true
        };
      });
    });
    _defineProperty(_this, "listRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "lastResult", -1);
    _defineProperty(_this, "_renderItem", function (chat, index) {
      var _this$props3 = _this.props,
        onPress = _this$props3.onPress,
        isOlx = _this$props3.isOlx,
        activeTab = _this$props3.activeTab;
      if (chat.username === '1' && !isOlx) return null;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatListItem["default"], {
        chat: chat,
        onPress: onPress,
        activeTab: activeTab,
        index: index !== undefined ? index : null,
        reloadChatList: _this.reloadChatList
      }, chat.roomname);
    });
    _defineProperty(_this, "tabsClick", function (tab) {
      var _this$props4 = _this.props,
        allTabClickAction = _this$props4.allTabClickAction,
        myShoppingTabClickAction = _this$props4.myShoppingTabClickAction,
        mySalesTabClickAction = _this$props4.mySalesTabClickAction,
        archivedTabClickAction = _this$props4.archivedTabClickAction,
        clickTabFavoriteAction = _this$props4.clickTabFavoriteAction,
        isChatTabsBuyerSeller = _this$props4.isChatTabsBuyerSeller,
        isChatTabsFavorite = _this$props4.isChatTabsFavorite,
        clickAllTabAction = _this$props4.clickAllTabAction,
        updateActiveTabAction = _this$props4.updateActiveTabAction;
      updateActiveTabAction(tab);
      _this.updateTabs(tab, isChatTabsFavorite, clickAllTabAction);
      if (tab === '1') {
        if (isChatTabsBuyerSeller) {
          allTabClickAction();
        }
      }
      if (tab === '2') {
        clickTabFavoriteAction();
      }
      if (tab === '3') {
        myShoppingTabClickAction();
      }
      if (tab === '4') {
        mySalesTabClickAction();
      }
      if (tab === '5') {
        archivedTabClickAction();
      }
    });
    return _this;
  }
  _inherits(ChatList, _Component);
  return _createClass(ChatList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.onscroll = this.onScroll;
      var _this$props5 = this.props,
        allTabViewAction = _this$props5.allTabViewAction,
        isChatTabsBuyerSeller = _this$props5.isChatTabsBuyerSeller;
      if (isChatTabsBuyerSeller) {
        allTabViewAction();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.onscroll = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props6 = this.props,
        isChatTabsBuyerSeller = _this$props6.isChatTabsBuyerSeller,
        isChatTabsFavorite = _this$props6.isChatTabsFavorite;
      var chatListKey = this.state.chatListKey;
      var chats = this.getChats();
      var renderSecurityCentral = function renderSecurityCentral() {
        var variantSecurityCentral = _this2.props.showSecurityCentral;
        if (variantSecurityCentral && variantSecurityCentral !== 'control') {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.WrapperSecurityChat, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_chatModReactComponentsCentralSecurityWeb.AlertBoxMessage, {
              idPage: "chat",
              variant: _this2.props.showSecurityCentral
            })
          });
        }
      };
      if (isChatTabsBuyerSeller) {
        var activeChats = chats.filter(function (chat) {
          return chat.adStatus === 'active' || chat.adStatus === 'active_sold';
        });
        var inactiveChats = chats.filter(function (chat) {
          return chat.adStatus !== 'active' && chat.adStatus !== 'active_sold';
        });
        var sellerChats = activeChats.filter(function (chat) {
          return chat.username === chat.sellerId;
        });
        var buyerChats = activeChats.filter(function (chat) {
          return chat.username === chat.buyerId;
        });
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.WrapperChatList, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.WrapperItems, {
            ref: this.listRef,
            onScroll: function onScroll(ev) {
              return _this2.onScroll(ev.nativeEvent);
            },
            className: "olx-list",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.TitlePage, {
              children: "Mensagens"
            }), renderSecurityCentral(), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Tabs, {
              onChange: this.tabsClick,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Tab, {
                label: "Todas",
                id: "1",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                  children: activeChats.length > 0 ? activeChats.map(function (chat, index) {
                    return _this2._renderItem(chat, index);
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmptyChatList.EmptyAllTab, {})
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Tab, {
                label: "Minhas Compras",
                id: "3",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                  children: buyerChats.length > 0 ? buyerChats.map(function (chat, index) {
                    return _this2._renderItem(chat, index);
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmptyChatList.EmptyMyPurchasesTab, {})
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Tab, {
                label: "Minhas Vendas",
                id: "4",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                  children: sellerChats.length > 0 ? sellerChats.map(function (chat, index) {
                    return _this2._renderItem(chat, index);
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmptyChatList.EmptyMySalesTab, {})
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Tab, {
                label: "Arquivadas",
                id: "5",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                  children: inactiveChats.length > 0 ? inactiveChats.map(function (chat, index) {
                    return _this2._renderItem(chat, index);
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmptyChatList.EmptyArchivedTab, {})
                })
              })]
            })]
          })
        }, chatListKey);
      }
      if (isChatTabsFavorite) {
        var favoritesChats = chats.filter(function (chat) {
          return chat.isFavoriteChat === true && (chat.adStatus === 'active' || chat.adStatus === 'active_sold');
        });
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.WrapperChatList, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.WrapperItems, {
            ref: this.listRef,
            onScroll: function onScroll(ev) {
              return _this2.onScroll(ev.nativeEvent);
            },
            className: "olx-list",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.TitlePage, {
              children: "Mensagens"
            }), renderSecurityCentral(), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Tabs, {
              onChange: this.tabsClick,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Tab, {
                label: "Todas",
                id: "1",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                  children: chats.map(function (chat, index) {
                    return _this2._renderItem(chat, index);
                  })
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Tab, {
                label: "Meus Favoritos",
                id: "2",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                  children: favoritesChats.length > 0 ? favoritesChats.map(function (chat, index) {
                    return _this2._renderItem(chat, index);
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmptyChatList.EmptyFavoriteTab, {})
                })
              })]
            })]
          })
        }, chatListKey);
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.WrapperChatList, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.WrapperItems, {
          ref: this.listRef,
          onScroll: function onScroll(ev) {
            return _this2.onScroll(ev.nativeEvent);
          },
          className: "olx-list",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.TitlePage, {
            children: "Mensagens"
          }), renderSecurityCentral(), chats.map(function (chat, index) {
            return _this2._renderItem(chat, index);
          })]
        })
      }, chatListKey);
    }
  }]);
}(_react.Component);
_defineProperty(ChatList, "propTypes", {
  chats: _propTypes.array.isRequired,
  onPress: _propTypes.func,
  getChatsAction: _propTypes.func.isRequired,
  oldestChat: _propTypes.object,
  loading: _propTypes.bool.isRequired,
  isChatTabsBuyerSeller: _propTypes.bool.isRequired,
  isChatTabsFavorite: _propTypes.bool.isRequired,
  myShoppingTabClickAction: _propTypes.func.isRequired,
  mySalesTabClickAction: _propTypes.func.isRequired,
  archivedTabClickAction: _propTypes.func.isRequired,
  allTabClickAction: _propTypes.func.isRequired,
  clickTabFavoriteAction: _propTypes.func.isRequired,
  clickAllTabAction: _propTypes.func.isRequired,
  updateActiveTabAction: _propTypes.func.isRequired,
  activeTab: _propTypes.string.isRequired
});
_defineProperty(ChatList, "defaultProps", {
  onPress: null,
  oldestChat: null
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var theme = ownProps.theme;
  return {
    oldestChat: (0, _selectors.getOldestChat)(state),
    isOlx: theme.brand === 'olx',
    isChatTabsBuyerSeller: (0, _selectors.isChatTabsBuyerSeller)(state),
    isChatTabsFavorite: (0, _selectors.isChatTabsFavorite)(state),
    activeTab: (0, _selectors.activeChatTab)(state),
    showSecurityCentral: (0, _selectors.showSecurityCentral)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    getChatsAction: _actions.getChats,
    myShoppingTabClickAction: _actions.myShoppingTabClick,
    mySalesTabClickAction: _actions.mySalesTabClick,
    archivedTabClickAction: _actions.archivedTabClick,
    allTabClickAction: _actions.allTabClick,
    allTabViewAction: _actions.allTabView,
    clickTabFavoriteAction: _actions.clickTabFavorite,
    clickAllTabAction: _actions.clickAllTab,
    updateActiveTabAction: _actions.updateActiveTab
  }, dispatch);
};
var _default = exports["default"] = (0, _styledComponents.withTheme)((0, _actions.connect)(mapStateToProps, mapDispatchToProps)(ChatList));